'use client'

import { useState } from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import { Link } from '@/lib/i18n/settings'

export type NavLinksProps = {
  navItems: Array<{
    href: string
    label: string
    name: string
  }>
}

export function NavLinks({ navItems }: NavLinksProps) {
  let [hoveredIndex, setHoveredIndex] = useState<number | null>(null)

  return (
    <>
      {navItems.map(({ label, href, name }, index) => (
        <Link
          key={name}
          href={href}
          className="relative -my-2 -mx-3 rounded-lg px-3 py-2 text-base font-bold text-gray-700 transition-colors delay-150 hover:text-gray-900 hover:delay-[0ms]"
          onMouseEnter={() => setHoveredIndex(index)}
          onMouseLeave={() => setHoveredIndex(null)}
        >
          <AnimatePresence>
            {hoveredIndex === index && (
              <motion.span
                className="absolute inset-0 rounded-lg bg-gray-100"
                layoutId="hoverBackground"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1, transition: { duration: 0.15 } }}
                exit={{
                  opacity: 0,
                  transition: { duration: 0.15, delay: 0.2 },
                }}
              />
            )}
          </AnimatePresence>
          <span className="relative z-10">{label}</span>
        </Link>
      ))}
    </>
  )
}
